import React, { useState } from 'react';
import { X, MessageSquare, Send } from 'lucide-react';
import axios from 'axios';
import { useApiHandler } from '../../../utils/apiHandler';

function TaskDetailsModal({ task, onClose, currentUser }) {
    const [newComment, setNewComment] = useState('');
    const [selectedStatus, setSelectedStatus] = useState(task.status);
    const [comments, setComments] = useState(task.comments || []);
    const apiHandler = useApiHandler(); // Use the custom API handler

    // Function to update the task status
    const handleStatusChange = async (status) => {
        console.log(status);
    };

    // Function to add a comment
    const handleAddComment = async () => {
        if (newComment.trim()) {
            try {
                // Send the comment to the server
                const response = await apiHandler.put(`admin/task/${task._id}`, { comment: newComment });
                console.log(response.data)
                if (response.data.success) {
                    const addedComment = {
                        id: Date.now(), // Ideally, use the ID from the API response
                        text: newComment,
                        userName: "admin", // Assuming currentUser contains the name
                        createdAt: new Date().toISOString(),
                    };

                    setComments((prevComments) => [...prevComments, addedComment]);
                    setNewComment('');
                }
            } catch (error) {
                console.error('Error adding comment:', error);
            }
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg max-w-2xl w-full p-6">
                <div className="flex justify-between items-center mb-6">
                    <div>
                        <h2 className="text-xl font-semibold text-gray-900">{task.taskDetails}</h2>
                    </div>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
                        <X className="h-5 w-5" />
                    </button>
                </div>

                <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                        Status
                    </label>
                    <div className="flex gap-2">
                        {['Not Started', 'In Progress', 'Completed'].map((status) => (
                            <button
                                key={status}
                                onClick={() => handleStatusChange(status)}
                                className={`px-4 py-2 rounded-lg text-sm ${selectedStatus === status
                                        ? 'bg-blue-600 text-white'
                                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                    }`}
                            >
                                {status}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="mb-6">
                    <div className="flex items-center gap-2 mb-3">
                        <MessageSquare className="h-4 w-4 text-gray-400" />
                        <h3 className="text-sm font-medium text-gray-900">Comments</h3>
                    </div>

                    <div className="space-y-4 mb-4 max-h-60 overflow-y-auto">
                        {comments.map((comment) => (
                            <div key={comment.id} className="bg-gray-50 rounded-lg p-3">
                                <div className="flex justify-between items-start mb-1">
                                    <span className="font-medium text-sm text-gray-900">
                                        {comment.userName} {/* Display author name */}
                                    </span>
                                    <span className="text-xs text-gray-500">
                                        {new Date(comment.createdAt).toLocaleString()}
                                    </span>
                                </div>
                                <p className="text-sm text-gray-600">{comment.text}</p>
                            </div>
                        ))}
                    </div>

                    <div className="flex gap-2">
                        <input
                            type="text"
                            placeholder="Add a comment..."
                            className="flex-1 p-2 border rounded-lg"
                            value={newComment}
                            onChange={(e) => setNewComment(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && handleAddComment()}
                        />
                        <button
                            onClick={handleAddComment}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                        >
                            <Send className="h-4 w-4" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TaskDetailsModal;
